import { E_FUNCTIONALITY } from "../../utils/functionalityVariable";
// import { COSTING_APP_URL, SAMPLE_APP_URL } from "../../constants/config";

export const LINKS = {
  PDMS_LEFT_OVER: '/pdms/left-over',
  PDMS_LEFT_OVER_CREATE: '/pdms/left-over/create',
  PDMS_QUANTITY_TAKEN: '/pdms/quantity-taken',
  PDMS_QUANTITY_TAKEN_CREATE: '/pdms/quantity-taken/create',
  PDMS_YARN_ALLOCATION: '/pdms/yarn-allocation',
  PDMS_YARN_ALLOCATION_DETAIL: '/pdms/yarn-allocation/:styleId',
  SIGNIN: "/signin",
  SIGNUP: "/signup",
  ACTIVATE_ACCOUNT: "/activate/account",
  HOME: "/",
  RAW_MATERIAL: "",
  PURCHASE_MANAGEMENT: "/purchaser",
  ACCOUNTING: "",
  YPO: "/purchaser/ypo",
  APO: "/purchaser/apo",
  LSPPO: "/purchaser/lsppo",
  YARN_FOLLOW_UP: "/yarn-follow-up",
  YARN_PACKING_LIST: "/yarn-packing-list",
  ACCOUNT_YARN: "/purchasing-management/ypo",
  ACCOUNT_ACCESSORY: "/purchasing-management/apo",
  ACCOUNT_SUB_YARN: "/purchasing-management/lsppo",
  WAREHOUSE_YARN_INVOICE: "/invoice/yarn",
  WAREHOUSE_ACCESSORY_INVOICE: "/invoice/accessory",
  WAREHOUSE_YARN_DELIVERY: "/incoming/yarn",
  WAREHOUSE_GARMENT_DELIVERY: "/incoming/garment",
  WAREHOUSE_ACC_DELIVERY: "/incoming/accessory",
  WAREHOUSE_LYCRA_DELIVERY: "/incoming/lycra",
  WAREHOUSE_ACCESSORY_DELIVERY: "/incoming/accessory",
  WAREHOUSE_FCD_DELIVERY: "/incoming/fcd",
  WAREHOUSE_YARN_STOCK: "/stock/yarn",
  WAREHOUSE_FCD_STOCK: "/stock/fcd",
  WAREHOUSE_GARMENT_STOCK: "/stock/garment",
  WAREHOUSE_ACC_STOCK: "/stock/accessory",
  WAREHOUSE_LYCRA_STOCK: "/stock/lycra",
  WAREHOUSE_ADJUSTMENT: "/stock/adjustment",
  W_YARN_RECEIVED_INVOICE: "/received/yarn",
  W_ACC_RECEIVED_INVOICE: "/received/accessory",
  W_LYCRA_RECEIVED_INVOICE: "/received/lycra",
  ORDER_HEAD: "/orderhead",
  ORDER_STYLE: "/orderstyle",
  BOOKING: "/booking",
  PROFILE: "/user/me",
  ADMIN_USER: "/user/user",
  DEPARTMENT: "/user/department",
  ROLE: "/user/role",
  ORDER_ACCESS: "/order-access",
  FUNCTIONALITY: "/managements/functionality",
  SUPPLIER: "/managements/supplier",
  OPTIONAL_SCAN_STEPS_ADMIN: "/managements/optional-scan-steps",
  PDMS_ACTIVATE_SCAN: "/activate-scan",
  PDMS: "/all_orders",
  PDMS_OPERATION: "/scan",
  PDMS_TICKET_DETAILS: "/ticket-details",
  PDMS_ORDER_SITUATION: "http://192.168.0.36:3022/Order_Situation",
  DAILY_REPORT_ORDER: "http://192.168.0.36:3022/Daily_Report_By_Order",
  DAILY_REPORT_MACHINE: "http://192.168.0.36:3022/Daily_Report_By_Machine",
  DAILY_REPORT_BY_SECTION: "http://192.168.0.36:3022/Daily_Report_By_Section",
  PDMS_MISSING_PIECES: "/pdms/missing-pieces",
  FCD_YARN_DYE: "/fcd/yarn-dye",
  FCD_PIECE_DYE: "/fcd/piece-dye",
  YARN_DYE_RECEIPE: "/gestion-receipe/yarn-dye",
  PIECE_DYE_RECEIPE: "/gestion-receipe/piece-dye",
  GESTION_MACHINE: "/gestion-machine/gestion-machine",
  GESTION_YARN_COMPO: "/gestion-compo/gestion-compo",
  GESTION_YARN_COUNT: "/gestion-count/gestion-count",
  GESTION_STOCK_RECIPE: "/fcd/gestion-stock/gestion-stock-receipe",
  RAPPORT_STOCK_RECEIPE: "/fcd/gestion-stock/rapport-gestion-receipe",
  COSTING_SHEET: "https://master.flexknit.com/costing/costing-sheets",
  SAMPLE_REF: "https://master.flexknit.com/costing/sample-references",
  PDMS_WORK_ORDERS:"https://master.flexknit.com/report/orders",
  ORDER_SITUATION:"https://master.flexknit.com/report/order-situation",
  ORDER_SITUATION_BY_SIZE:"https://master.flexknit.com/report/order-situation-by-size",
  PRODUCTION_DAILY_SECTION:"https://master.flexknit.com/report/production-daily",
  KNITTING_MACHINE_REPORT:"https://master.flexknit.com/report/daily-report-by-machine-knitting",
  KNITTING_GENERAL_REPORT:"https://master.flexknit.com/report/knitting-report-by-order",
  MISSING_PIECE:"https://master.flexknit.com/report/missing-piece",
  KNITTING_MAHCINE_UTILIZATION:"https://master.flexknit.com/report/knitting-machines-in-operation",
  PERFORMANCE_OPERATOR:"https://master.flexknit.com/report/performance-per-operator",
  PERFORMANCE_OPERATOR_DETAIL:"https://master.flexknit.com/report/performance-per-operator-detail",
  PIECE_ROUTINE:"https://master.flexknit.com/report/piece-route-tracking",
  PIECE_ROUTE_TRACKING:"https://master.flexknit.com/report/piece-route-tracking",
  PURCHASER_MANAGEMENT:"https://master.flexknit.com/dn",
  OPERATOR_EFFICIENCY:"https://master.flexknit.com/report/operator-efficiency",
};


interface IMenu {
  label: string;
  link: string;
  user_functionalities: Array<string>;
  subMenu: Array<{
    label: string;
    link: string;
    directLink?: boolean;
    user_functionalities: Array<string>;
  }>;
}

export const MENU: Array<IMenu> = [
  {
    label: "Orders",
    link: "/order",
    subMenu: [
      {
        label: "Orders",
        link: "/orderhead",
        user_functionalities: [],
      },
      {
        label: "Order style",
        link: "/orderstyle",
        user_functionalities: [],
      },
      {
        label: "Booking",
        link: LINKS.BOOKING,
        user_functionalities: [],
      },
      {
        label: "Order access",
        link: LINKS.ORDER_ACCESS,
        user_functionalities: [E_FUNCTIONALITY.menu_setting_role],
      },
    ],
    user_functionalities: [E_FUNCTIONALITY.menu_order],
  },
  {
    label: "Costing sheet and sample references",
    link: "",
    subMenu: [
      {
        label: "Costing sheet ",
        link: LINKS.COSTING_SHEET,
        directLink: true,
        user_functionalities: [],
      },
      {
        label: "Sample references ",
        link: LINKS.SAMPLE_REF,
        directLink: true,
        user_functionalities: [],
      },
    ],
    user_functionalities: [E_FUNCTIONALITY.menu_costing_sheet_sample_references],
  },
  {
    label: "Raw Material",
    link: "",
    subMenu: [
      {
        label: "Purchaser",
        link: "/purchaser/ypo",
        user_functionalities: [],
      },
      {
        label: "Purchasing management",
        link: "/purchasing-management/ypo",
        user_functionalities: [],
      },
      {
        label: "Yarn Follow Up",
        link: "/yarn-follow-up",
        user_functionalities: [],
      },
      {
        label: "Yarn Packing list",
        link: "/yarn-packing-list",
        user_functionalities: [],
      },
      
    ],
    user_functionalities: [E_FUNCTIONALITY.menu_purchase_order],
  },
  {
    label: "Warehouse",
    link: "",
    subMenu: [
      {
        label: "Inventory",
        link: "/stock/",
        user_functionalities: [E_FUNCTIONALITY.sub_menu_inventory],
      },
      {
        label: "Pending Invoice",
        link: "/invoice/",
        user_functionalities: [E_FUNCTIONALITY.sub_menu_pending_invoice],
      },
      {
        label: "Received invoices",
        link: "/received/",
        user_functionalities: [E_FUNCTIONALITY.sub_menu_received_invoice],
      },
      {
        label: "Delivery note",
        link: "/incoming/",
        user_functionalities: [E_FUNCTIONALITY.sub_menu_delivery_note],
      },
    ],
    user_functionalities: [E_FUNCTIONALITY.menu_stock],
  },
  {
    label: "Purchaser",
    link: "",
    subMenu: [
      {
        label: "Purchaser Management",
        link: LINKS.PURCHASER_MANAGEMENT,
        directLink: true,
        user_functionalities: [],
      },
    ],
    user_functionalities: [E_FUNCTIONALITY.menu_purchaser_global],
  },
  {
    label: "FCD",
    link: "",
    subMenu:[
       {
        label: "Gestion Receipe",
        link: "/gestion-receipe/piece-dye",
        user_functionalities: [],
      },
      {
        label: "Fcd",
        link: "/fcd/yarn-dye",
        user_functionalities: [],
      },
      {
        label: "Gestion Stock",
        link: "/fcd/gestion-stock/gestion-stock-receipe",
        user_functionalities: [],
      }
    ],
    user_functionalities: [E_FUNCTIONALITY.menu_fcd],
  }, 
  {
    label: "Pdms",
    link: "/pdms",
    subMenu: [
      {
        label: "Orders",
        link: LINKS.PDMS,
        user_functionalities: [E_FUNCTIONALITY.sub_menu_pdms_order],
      },
      {
        label: "Scan",
        link: LINKS.PDMS_OPERATION,
        user_functionalities: [E_FUNCTIONALITY.sub_menu_pdms_scan],
      },
      {
        label: "Ticket Details",
        link: LINKS.PDMS_TICKET_DETAILS,
        user_functionalities: [E_FUNCTIONALITY.sub_menu_pdms_ticket_details],
      },
      {
        label: "Missing Pieces",
        link: LINKS.PDMS_MISSING_PIECES,
        user_functionalities: [E_FUNCTIONALITY.sub_menu_pdms_missing_pieces],
      },
      {
        label: 'Yarn Requirement & Allocation',
        link: LINKS.PDMS_YARN_ALLOCATION,
        user_functionalities: [E_FUNCTIONALITY.sub_menu_yarn_requirement_allocation],
      },
      {
        label: 'Left Over',
        link: LINKS.PDMS_LEFT_OVER,
        user_functionalities: [E_FUNCTIONALITY.sub_menu_pdms_left_over],
      },
      {
        label: 'Quantity taken',
        link: LINKS.PDMS_QUANTITY_TAKEN,
        user_functionalities: [E_FUNCTIONALITY.sub_menu_pdms_quantity_taken],
      },
    ],
    user_functionalities: [E_FUNCTIONALITY.menu_pdms],
  },
  {
    label: "Reporting Pdms",
    link: "/pdms",
    subMenu: [
      {
        label: "Work Orders",
        link: LINKS.PDMS_WORK_ORDERS,
        directLink: true,
        user_functionalities: [],
      },
      {
        label: "Order situation",
        link: LINKS.ORDER_SITUATION,
        directLink: true,
        user_functionalities: [],
      },
      {
        label: "Order Sitution by Size",
        link: LINKS.ORDER_SITUATION_BY_SIZE,
        directLink: true,
        user_functionalities: [],
      },
      {
        label: " Production Daily by Section",
        link: LINKS.PRODUCTION_DAILY_SECTION,
        directLink: true,
        user_functionalities: [],
      },
      {
        label: "Knitting Report By Machine",
        link: LINKS.KNITTING_MACHINE_REPORT,
        directLink: true,
        user_functionalities: [],
      },
      {
        label: "Missing Piece",
        link: LINKS.MISSING_PIECE,
        directLink: true,
        user_functionalities: [],
      },
      {
        label: "Knitting Machine Utilization",
        link: LINKS.KNITTING_MAHCINE_UTILIZATION,
        directLink: true,
        user_functionalities: [],
      },
      {
        label: "Knitting General Report",
        link: LINKS.KNITTING_GENERAL_REPORT,
        directLink: true,
        user_functionalities: [],
      },
      {
        label: "Performance operator",
        link: LINKS.PERFORMANCE_OPERATOR,
        directLink: true,
        user_functionalities: [],
      },
      {
        label: "Operator efficiency",
        link: LINKS.OPERATOR_EFFICIENCY,
        directLink: true,
        user_functionalities: [],
      },
      {
        label: "Performance operator detail",
        link: LINKS.PERFORMANCE_OPERATOR_DETAIL,
        directLink: true,
        user_functionalities: [],
      },
      {
        label: "Piece Route tracking",
        link: LINKS.PIECE_ROUTINE,
        directLink: true,
        user_functionalities: [],
      },
      
    ],
    user_functionalities: [E_FUNCTIONALITY.menu_reporting_pdms],
  },
];

export const SUB_MENU = {
  rawMaterial: {
    purchaser: [
      { link: "/purchaser/ypo", label: "Ypo" },
      { link: "/purchaser/apo", label: "Apo" },
      { link: "/purchaser/lsppo", label: "Lsppo" },
    ],
    accounting: [
      { link: "/purchasing-management/ypo", label: "Ypo" },
      { link: "/purchasing-management/apo", label: "Apo" },
      { link: "/purchasing-management/lsppo", label: "Lsppo" },
    ],
    yarnFup: [{ link: "/yarn-follow-up", label: "Yarn follow up" }],
    Yarn_PL: [{ link: "/yarn-packing-list", label: "Yarn packing list" }], 
  },

  fcd:{
    receipe: [
      { link: "/gestion-receipe/piece-dye", label: "Piece Dye Receipe" },
      { link: "/gestion-receipe/yarn-dye", label: "Yarn Dye Receipe" },
    ],
    fcd: [
      { link: "/fcd/yarn-dye", label: "Yarn Dye" },
      { link: "/fcd/piece-dye", label: "Piece Dye" },
    ],
    gestionStockReceipe: [
      {link: "/fcd/gestion-stock/gestion-stock-receipe", label:"Gestion Stock Receipe"},
      {link: "/fcd/gestion-stock/rapport-gestion-receipe", label:"Rapport"},
    ]
  },

  product: {
    order: [
      { link: "/orderhead", label: "Orders" },
      { link: "/orderstyle", label: "Order styles" },
      { link: LINKS.BOOKING, label: "Booking" },
      { link: LINKS.ORDER_ACCESS, label: "Order access", user_functionalities: [E_FUNCTIONALITY.menu_setting_role] },
    ],
  },
  warehouse: {
    invoice: [
      { link: "/invoice/yarn", label: "Yarn", user_functionalities: [E_FUNCTIONALITY.sub_menu_pending_invoice_tab_yarn] },
      { link: "/invoice/accessory", label: "Accessory", user_functionalities: [E_FUNCTIONALITY.sub_menu_pending_invoice_tab_accessory] },
    ],
    received_invoice: [
      { link: "/received/yarn", label: "Yarn", user_functionalities: [E_FUNCTIONALITY.sub_menu_received_invoice_tab_yarn] },
      { link: "/received/accessory", label: "Accessory", user_functionalities: [E_FUNCTIONALITY.sub_menu_received_invoice_tab_accessory] },
    ],
    delivery: [
      { link: "/incoming/yarn", label: "Yarn", user_functionalities: [E_FUNCTIONALITY.sub_menu_delivery_note_yarn] },
      { link: "/incoming/accessory", label: "Accessory", user_functionalities: [E_FUNCTIONALITY.sub_menu_delivery_note_accessory] },
      { link: "/incoming/fcd", label: "Fcd", user_functionalities: [E_FUNCTIONALITY.sub_menu_delivery_note_fcd] },
      { link: "/incoming/garment", label: "Garment", user_functionalities: [E_FUNCTIONALITY.sub_menu_delivery_note_garment] },
    ],
  },
  pdms: {
    leftOver: [
      {
        link: LINKS.PDMS_LEFT_OVER,
        label: "Left Over",
        user_functionalities: [E_FUNCTIONALITY.sub_menu_pdms_left_over],
      },
    ],
    quantityTaken: [
      {
        link: LINKS.PDMS_QUANTITY_TAKEN,
        label: "Quantity taken",
        user_functionalities: [E_FUNCTIONALITY.sub_menu_pdms_quantity_taken],
      },
    ],
    yarnAllocation: [
      {
        label: 'Yarn Requirement & Allocation',
        link: LINKS.PDMS_YARN_ALLOCATION,
        user_functionalities: [E_FUNCTIONALITY.sub_menu_yarn_requirement_allocation]
      },
    ],
    orders: [{ link: "/pdms/all_orders", label: "All Orders" }],
    productions: [{ link: "/pdms/operation", label: "Scan " }],
    ticketDetails: [{ link: "/pdms/ticket-details", label: "Ticket Details " }],
    missingPieces: [{ label: "Missing Pieces", link: "/pdms/missing-pieces" }],
    activateScan: [{ label: "Activate Scan", link: "/pdms/activate-scan" }],
  },
  stock: [
    { link: "/stock/yarn", label: "Yarn", user_functionalities: [E_FUNCTIONALITY.sub_menu_warehouse_yarn] },
    { link: "/stock/accessory", label: "Accessory", user_functionalities: [E_FUNCTIONALITY.sub_menu_warehouse_accessory] },
    { link: "/stock/garment", label: "Garment", user_functionalities: [E_FUNCTIONALITY.sub_menu_warehouse_garment] },
    { link: "/stock/fcd", label: "Fcd", user_functionalities: [E_FUNCTIONALITY.sub_menu_warehouse_fcd] },
    { link: LINKS.WAREHOUSE_ADJUSTMENT, label: "Adjustments",  user_functionalities: [E_FUNCTIONALITY.sub_menu_warehouse_adjustments] },
  ],
  admin: [
    { link: LINKS.ADMIN_USER, label: "User" },
    { link: LINKS.DEPARTMENT, label: "Department" },
    { link: LINKS.ROLE, label: "Role" },
    { link: LINKS.FUNCTIONALITY, label: "Functionality" },
    { link: LINKS.SUPPLIER, label: "Supplier" },
  ],
  users: [
    { link: LINKS.ADMIN_USER,   label: "User",       user_functionalities: [E_FUNCTIONALITY.menu_setting_user] },
    { link: LINKS.DEPARTMENT,   label: "Department", user_functionalities: [E_FUNCTIONALITY.menu_setting_department] },
    { link: LINKS.ROLE,         label: "Role",       user_functionalities: [E_FUNCTIONALITY.menu_setting_role] },
  ],
  managements: [
    { link: LINKS.FUNCTIONALITY,    label: "Functionality",   user_functionalities: [E_FUNCTIONALITY.menu_setting_functionality] },
    { link: LINKS.SUPPLIER,         label: "Supplier",        user_functionalities: [E_FUNCTIONALITY.menu_setting_supplier] },
    { link: LINKS.GESTION_MACHINE,  label: "Gestion Machine", user_functionalities: [E_FUNCTIONALITY.menu_setting_gestion_machine] },
    { link: LINKS.GESTION_YARN_COMPO,  label: "Gestion Compo", user_functionalities: [E_FUNCTIONALITY.menu_setting_gestion_yarn_composition] },
    { link: LINKS.GESTION_YARN_COUNT,  label: "Gestion Count", user_functionalities: [E_FUNCTIONALITY.menu_setting_gestion_yarn_count] },
    { link: LINKS.OPTIONAL_SCAN_STEPS_ADMIN, label: "Scan Process", user_functionalities: [E_FUNCTIONALITY.menu_setting_managements] },
    { link: LINKS.PDMS_ACTIVATE_SCAN, label: "Activate Scan", user_functionalities: [E_FUNCTIONALITY.sub_menu_pdms_scan] },
  ],
};
